import PropTypes from 'prop-types';

import React, {
    createContext,
    useContext,
    useMemo,
    useState,
} from 'react';

const noop = async () => { };

/* ========================================================================= */
/* Hook(s) */
/* ========================================================================= */

const LayoutContext = createContext({
    showSidebar: false,
    setShowSidebar: () => { },
});

/* ========================================================================= */
/* Hook(s) */
/* ========================================================================= */

/**
 * @hook useLayout
 */
const useLayout = () => {
    const context = useContext(LayoutContext);

    if (context === undefined) {
        throw new Error('useLayout must be used within a LayoutProvider.');
    }

    return context;
};

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @component LayoutProvider
 * @props (see propTypes)
 */
const LayoutProvider = ({ children, }) => {
    const [showSidebar, setShowSidebar] = useState(false);

    return (
        <LayoutContext.Provider value={useMemo(() => {
            return {
                setShowSidebar,
                showSidebar,
            };
        }, [
            setShowSidebar,
            showSidebar,
        ])}>
            {children}
        </LayoutContext.Provider>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

LayoutContext.displayName = 'LayoutContext';

LayoutProvider.propTypes = {
    children: PropTypes.any,
};

export {
    LayoutContext,
    LayoutProvider,
    useLayout
};
